import React, { forwardRef, useId } from "react";
import "../../css/designSystem/CheckBox.css";

const Checkbox = forwardRef(
  (
    {
      id,
      label,
      children,
      error,
      className = "",
      labelClassName = "content text-primary-1",
      ...props
    },
    ref,
  ) => {
    const generatedId = useId();
    const checkboxId = id || `checkbox-${generatedId.replace(/:/g, "")}`;
    const errorId = error ? `${checkboxId}-error` : undefined;

    return (
      <div className={`checkbox-field ${className}`.trim()}>
        <div className="checkbox-field__control">
          <input
            ref={ref}
            id={checkboxId}
            className="checkbox-field__input"
            type="checkbox"
            aria-invalid={Boolean(error)}
            aria-describedby={errorId}
            {...props}
          />
          <label
            className={`checkbox-field__label ${labelClassName}`.trim()}
            htmlFor={checkboxId}
          >
            <span className="checkbox-field__box" aria-hidden="true" />
            <span>{children ?? label}</span>
          </label>
        </div>
        {error && (
          <span id={errorId} className="body2 text-error" role="alert">
            {error}
          </span>
        )}
      </div>
    );
  },
);

Checkbox.displayName = "Checkbox";

export default Checkbox;
